import http from "@/http/aisea/axios";
const resource = "/enterprises/crews";

export default {
  search(enterpriseCrewId, payload) {
    return http.get(`${resource}/${enterpriseCrewId}/manning/vessels`, {
      params: payload,
    });
  },

  fetch(enterpriseCrewId, id) {
    return http.get(`${resource}/${enterpriseCrewId}/manning/vessels/${id}`);
  },

  add(enterpriseCrewId, payload) {
    return http.post(
      `${resource}/${enterpriseCrewId}/manning/vessels`,
      payload
    );
  },

  update(enterpriseCrewId, enterpriseManningVesselCrewId, payload) {
    return http.put(
      `${resource}/${enterpriseCrewId}/manning/vessels/${enterpriseManningVesselCrewId}`,
      payload
    );
  },

  delete(enterpriseCrewId, enterpriseManningVesselCrewId, payload) {
    return http.delete(
      `${resource}/${enterpriseCrewId}/manning/vessels/${enterpriseManningVesselCrewId}`,
      { data: payload }
    );
  },

  transfer(enterpriseCrewId, enterpriseManningVesselCrewId, payload) {
    return http.put(
      `${resource}/${enterpriseCrewId}/manning/vessels/${enterpriseManningVesselCrewId}/vessel_change`,
      payload
    );
  },
};
